import { GAME_ANALYSIS_STATUS_BLOCKING_PRIORITY_EDIT } from "./constants";

/** Dynamic-grid cells may be null, undefined, or "" when unset. */
export function isDiscoverGamesGridCellEmpty(value: unknown): value is null | undefined | "" {
	return value === null || value === undefined || value === "";
}

export function isPriorityEditableForStatus(status: unknown): boolean {
	if (isDiscoverGamesGridCellEmpty(status)) {
		return true;
	}
	return !GAME_ANALYSIS_STATUS_BLOCKING_PRIORITY_EDIT.has(String(status).trim());
}
